export const QueryKey = 'labs'
export const Labs = '/api/v1/labs'
